import { gql } from 'apollo-angular'

export const CANCEL_SCHEDULED_CHANGE = gql`
  mutation DeleteSubscriptionScheduledChange($scheduledChangeId: Int!) {
    deleteSubscriptionScheduledChange(id: $scheduledChangeId) {
      subscription {
        id
      }
    }
  }
`
